import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from '@hooks';
import styled from 'styled-components';
import cx from 'classnames';
import Button from '../Button';

const SubTitle = styled.p`
    line-height: 1.7;
    font-size: 1rem;
    font-weight: 400;
    text-transform: capitalize;
    color: rgba(0, 0, 0, 0.6);
    margin: 0;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    overflow: hidden;
`;

const ConfirmModal = ({
    initModal = false,
    toggleModal = function () {
        initModal = !initModal;
    },
    okCallback,
    cancelCallback,
    callbackParam,
    header = { title: '', subTitle: '', className: '' },
    confirmText = 'Are you sure?',
    removeCancel,
    okClassName,
    okButtonTitle,
    className,
    ...restProps
}) => {
    const t = useTranslation('ConfirmModal');

    return (
        <Modal
            backdrop={'static'}
            container={document.getElementsByClassName('app-container')[0]}
            className={cx('pnt-modal', className)}
            isOpen={initModal}
            toggle={toggleModal}
            {...restProps}
        >
            <ModalHeader className={header.className} toggle={toggleModal}>
                {header.title ? header.title : t('Confirm')}
                {!!header.subTitle && <SubTitle>{header.subTitle}</SubTitle>}
            </ModalHeader>
            <ModalBody>{typeof confirmText === 'string' ? t(confirmText) : confirmText}</ModalBody>
            <ModalFooter>
                {!removeCancel && (
                    <Button
                        className={'btn-gray'}
                        onClick={() => {
                            if (typeof cancelCallback === 'function') {
                                cancelCallback(callbackParam);
                            }
                            toggleModal();
                        }}
                    >
                        {t('Cancel')}
                    </Button>
                )}

                <Button
                    className={cx(okClassName, 'btn-secondary')}
                    onClick={() => {
                        if (typeof okCallback === 'function') {
                            okCallback(callbackParam);
                        }
                        toggleModal();
                    }}
                >
                    {t('OK')}
                </Button>
            </ModalFooter>
            {/*
                modal react-select portal
                modal의 경우 app-main__inner 태그 밖에 생성되므로
                select menu portal 대상을 내부에서 정의해야 함
            */}
            <div id="modal-select-container" />
        </Modal>
    );
};

export default ConfirmModal;
